/*
 * @Date: 2021-07-14 22:42:26
 * @LastEditors: 于鸿儒
 * @LastEditTime: 2021-07-17 21:48:19
 * @FilePath: /fdmba2021/src/main.js
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
import animate from 'animate.css';
Vue.use(VideoPlayer)
Vue.use(animate);
Vue.config.productionTip = false
router.addRoutes([
  {
    path: '/',
    name: 'index',
    component: () => import('./views/index')
},
])
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
